import { jsx, jsxs } from 'react/jsx-runtime';
import 'react';
import 'styled-components';
import '../../../../theme/GlobalStyle.js';
import 'react-helmet-async';
import 'lodash';
import ThemedComponentWrapper from '../../../../theme/ThemedComponentWrapper.js';
import 'luxon';
import 'ethereum-blockies-base64';
import '../../../icons/ActivityIcon.js';
import '../../../icons/ArrowDownIcon.js';
import '../../../icons/ArrowDownRightCircleIcon.js';
import '../../../icons/ArrowLeftAlignIcon.js';
import '../../../icons/ArrowLeftIcon.js';
import '../../../icons/ArrowRightAlignIcon.js';
import '../../../icons/ArrowRightIcon.js';
import '../../../icons/ArrowSwitchIcon.js';
import '../../../icons/ArrowUpIcon.js';
import '../../../icons/ArrowUpRightCircleIcon.js';
import '../../../icons/ArrowsAngleExpandIcon.js';
import '../../../icons/BankIcon.js';
import CheckIcon from '../../../icons/CheckIcon.js';
import '../../../icons/ChevronDownIcon.js';
import '../../../icons/ChevronRightIcon.js';
import '../../../icons/ChevronUpIcon.js';
import '../../../icons/CopyIcon.js';
import '../../../icons/CrossIcon.js';
import '../../../icons/DaiIcon.js';
import '../../../icons/DangerIcon.js';
import '../../../icons/DownSortIcon.js';
import '../../../icons/ExclamationTriangleIcon.js';
import '../../../icons/ExpandKpiIcon.js';
import '../../../icons/EyeIcon.js';
import '../../../icons/EyeSlashIcon.js';
import '../../../icons/Grid1x2Icon.js';
import '../../../icons/InfoCircleIcon.js';
import '../../../icons/ListIcon.js';
import '../../../icons/LockIcon.js';
import '../../../icons/MediumIcon.js';
import '../../../icons/MoonIcon.js';
import '../../../icons/PiggyBankIcon.js';
import '../../../icons/QuestionMarkCircleIcon.js';
import '../../../icons/ShieldIcon.js';
import '../../../icons/SunIcon.js';
import '../../../icons/UpSortIcon.js';
import '../../../icons/XIcon.js';
import '../../../icons/InfinityIcon.js';
import '../../../icons/ArrowUpRightBoxIcon.js';
import '../../../atoms/layout/Stack/Stack.js';
import '../../../atoms/Table/components/Pagination/Pagination.js';
import '../../../atoms/Table/Table.js';
import '../../../atoms/ToggleSwitch.js';
import '@floating-ui/react';
import '../../../atoms/Tooltip/components/TooltipContext.js';
import '../../CurrencyValue/components/Value.js';
import '../../KpiCard/KpiCard.js';
import '../../PercentageValue.js';
import '../../Tabs/Tabs.js';
import '../../TrendValue.js';
import '../../../pictograms/EthPictogram.js';
import '../../../pictograms/EtherScanPictogram.js';
import '../../../pictograms/DebankPictogram.js';
import '../../../pictograms/ZapperPictogram.js';
import '../../../pictograms/DaiPictogram.js';
import '../../Modal/Modal.js';
import '../../../charts/ChartKpis/ChartKpi.js';
import '../../../charts/ChartJS.js';
import '../../../charts/Heatmap/Heatmap.js';
import 'randomcolor';
import 'd3';
import '../../../XRay.js';

function DropdownOption({ children, onClick, selected, iconSize, ...rest }) {
    return (jsx(ThemedComponentWrapper, { name: "dropdownOption", onClick: onClick, ...rest, children: typeof children === 'function' ? (children(selected)) : selected ? (jsxs(ThemedComponentWrapper, { name: "dropdownOptionSelected", children: [children, " ", jsx(CheckIcon, { size: iconSize })] })) : (children) }));
}

export { DropdownOption as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
